import { NodeModel } from "../_model/NodeModel";
import { DecorationMultipleInput } from "./decorationMultipleInput";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class MultipleInput extends NodeModel {
  constructor() {
    super("MultipleInput");

    this.type = new Types().MultipleInput;
    this.title = "MultipleInput";
    this.x = 0;
    this.y = 0;
    this.xText = () => this.x + this.width / 2;
    this.yText = () => this.heightValue + this.y;
    this.height = 55;
    this.pathLineCenter = () =>
      `M${this.x},${this.y + this.height / 2}L${this.x + this.width},${this.y +
        this.height / 2}`;
    this.heightText = this.height / 2 - 5;
    this.heightValue = this.height - 2;
    this.width = 110;
    this.data = [new Properties({ ...this, height: 0 })];
    this.dataType = "";

    this.decorate = async function(callback) {
      this.decorator = new DecorationMultipleInput();
      await this.decorator.init(this, callback);
    };

    this.update = (nodeEdited) => {
      this.dataType = nodeEdited.dataType;
      if (nodeEdited.attrs || nodeEdited.data) {
        this.data = nodeEdited.attrs ? nodeEdited.attrs : nodeEdited.data;
        let defaultValue = "-9999";
        if (defaultValue == "-9999")
          defaultValue = this.data[this.data.length - 1].value;
        this.data.forEach((a) => {
          a.isInput = true;
          a.caption = "";
          a.unit = "";
          a.height = 0;
          a.value = defaultValue;
        });
      }

      this.title = nodeEdited.title;
      let valueLenght = this.data.length > 0 ? this.data[0].value.length : 0;
      let lenghtOfFont =
        this.title.length > valueLenght
          ? this.title.length * 9
          : valueLenght * 9;
      this.width = lenghtOfFont;

      this.decorator.setTextAndAdjustWidth();
    };

    this.clone = function() {
      let cloned = new MultipleInput();
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type;
      cloned.title = this.title;
      cloned.width = this.width;
      cloned.x = this.x;
      cloned.y = this.y;
      cloned.decorator = null
      cloned.readOnly = this.readOnly;
			cloned.expressionVisible = this.expressionVisible;
      cloned.dataType = this.dataType;
      cloned.data = this.data.map((d) => d.clone());

      return cloned;
    };

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.title = node.title;
      this.dataType = node.dataType;
      this.data = node.data.map((d) => new Properties({ ...d }));
    };
  }
}

export { MultipleInput };
